module.exports = __webpack_public_path__ + "img/046-get-money.0ed3bc21.svg";